import React from 'react';

/**
 * Создаем контекст для пользователя
 */
export default React.createContext({});
